import { useState, useEffect } from "react";
import { api } from "../../config/api";
import { BackEndRoutes } from "../../config/back-end-routes";
import { toast } from "react-toastify";

const useDashboardData = () => {
  const [dadosPedidos, setDadosPedidos] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Verifica se os dados já foram carregados, evitando chamadas duplicadas
    if (dadosPedidos) return; // Caso os dados já tenham sido carregados, não faz outra requisição

    const getDashboardData = () => {
      setLoading(true);
      setError(null);

      api.get(`${BackEndRoutes.routes.DASHBOARD}`)
        .then((response) => {
          setDadosPedidos(response.data); // Salva os dados no estado
        })
        .catch((error) => {
          console.error("Erro ao buscar dados", error);
          setError("Falha ao buscar dados. Por favor, tente novamente.");
          toast.error("Falha ao buscar dados. Por favor, tente novamente.");
        })
        .finally(() => {
          setLoading(false);
        });
    };

    getDashboardData(); // Faz a requisição
  }, [dadosPedidos]); // Só faz a requisição quando os dados não estiverem carregados

  return { dadosPedidos, loading, error };
};

export default useDashboardData;
